import {useEffect, useRef} from 'react';

export default function useInterval(callback: () => unknown, delay: number) {
  const savedCallback = useRef<() => unknown>();
  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
